(() => {
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, String(value)); } catch { /* Preferences are optional. */ } }
  };
  const money = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);

  function initializePacks(root = document) {
    root.querySelectorAll('[data-vl-pack]').forEach(pack => {
      if (pack.dataset.initialized) return;
      const info = pack.closest('product-info');
      const quantity = info?.querySelector('input[name="quantity"]');
      const nativeContainer = quantity?.closest('.product-form__quantity');
      if (!quantity || !nativeContainer) return;
      pack.dataset.initialized = 'true';
      pack.hidden = false;
      nativeContainer.hidden = true;
      const unitPrice = Number(pack.dataset.unitPrice);
      const currency = pack.dataset.currency || 'USD';
      const summary = pack.querySelector('[data-vl-pack-summary]');
      const custom = pack.querySelector('[data-vl-custom-quantity]');
      custom.setAttribute('aria-controls', nativeContainer.id);
      const update = () => {
        const count = Number(quantity.value);
        if (!Number.isInteger(count) || count < 1) return;
        const total = unitPrice * count - (count >= 3 ? Math.round(unitPrice * count * 0.15) : 0);
        summary.textContent = `${count} ${count === 1 ? 'bottle' : 'bottles'} · ${money(total, currency)}${count >= 3 ? ' · 15% saving included' : ''}`;
        pack.querySelectorAll('input[type="radio"]').forEach(radio => { radio.checked = Number(radio.value) === count; });
        const stickyPrice = document.querySelector('[data-vl-sticky] .vl-sticky-buy__price');
        if (stickyPrice) stickyPrice.textContent = `${count} ${count === 1 ? 'bottle' : 'bottles'} · ${money(total, currency)}`;
      };
      pack.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        quantity.value = event.target.value;
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        nativeContainer.hidden = true;
        custom.setAttribute('aria-expanded', 'false');
        update();
      });
      quantity.addEventListener('input', update);
      quantity.addEventListener('change', update);
      custom.addEventListener('click', () => {
        nativeContainer.hidden = !nativeContainer.hidden;
        custom.setAttribute('aria-expanded', String(!nativeContainer.hidden));
        if (!nativeContainer.hidden) quantity.focus();
      });
      update();
    });
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-vl-add]');
    if (!button || button.disabled) return;
    const variant = Number(button.dataset.variant);
    if (!Number.isSafeInteger(variant) || variant < 1) return;
    const originalText = button.textContent;
    const scope = button.closest('.vl-formula-card, .vl-cart-suggestion');
    const error = scope?.querySelector('[data-vl-add-error]');
    button.disabled = true;
    button.textContent = 'Adding…';
    if (error) error.hidden = true;
    storage.set('vl-cart-engaged', Date.now());
    let cartAdded = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const drawerWasOpen = drawer?.classList.contains('active');
      if (drawer && !drawerWasOpen) drawer.setActiveElement(button);
      const body = { items: [{ id: variant, quantity: 1 }], sections_url: window.location.pathname };
      if (drawer) body.sections = drawer.getSectionsToRender().map(section => section.id);
      const base = window.routes?.cart_add_url || '/cart/add';
      const response = await fetch(base.endsWith('.js') ? base : `${base}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try its product page.');
      cartAdded = true;
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vitenia-quick-add', cartData: result });
      const currentDrawer = document.querySelector('cart-drawer');
      if (currentDrawer && result.sections) {
        currentDrawer.classList.remove('is-empty');
        currentDrawer.renderContents(result);
        if (drawerWasOpen && typeof trapFocus === 'function') trapFocus(currentDrawer.querySelector('#CartDrawer'), currentDrawer.querySelector('.drawer__close'));
      } else {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } catch (failure) {
      if (cartAdded) { window.location.assign(window.routes?.cart_url || '/cart'); return; }
      if (error) { error.textContent = failure.message || 'We could not confirm the cart update. Please check your cart.'; error.hidden = false; }
    } finally {
      if (button.isConnected) { button.disabled = false; button.textContent = originalText; }
    }
  });

  document.addEventListener('submit', event => {
    if (event.target.getAttribute('action')?.includes('/cart/add')) storage.set('vl-cart-engaged', Date.now());
  }, true);

  initializePacks();
  document.addEventListener('shopify:section:load', event => initializePacks(event.target));
})();
